class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.clearButton = this.querySelector('.search-page__icon--clear');
    
    if (this.input && this.clearButton) {
      this.input.focus();
      this.clearButton.addEventListener('click', this.clearInput.bind(this));
      this.input.addEventListener('input', this.handleInput.bind(this));
      
      // Initial state
      this.toggleClearButton();
    }
  }

  clearInput() {
    this.input.value = '';
    this.input.focus();
    this.handleInput();
  }

  handleInput() {
    this.toggleClearButton();
    
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.performSearch(this.input.value);
    }, 500);
  }

  toggleClearButton() {
    if (this.input.value.length > 0) {
      this.clearButton.style.display = 'flex';
    } else {
      this.clearButton.style.display = 'none';
    }
  }

  performSearch(query) {
    const params = new URLSearchParams(window.location.search);
    
    if (query.trim() === '') {
      params.delete('q');
    } else {
      params.set('q', query);
    }
    
    // Reset page on new search
    params.delete('page');

    // Remove the internal flags from the URL that users see so it stays clean
    params.delete('options[prefix]');
    params.delete('type');

    const queryString = params.toString();
    const nextUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
    
    history.replaceState(null, '', nextUrl);
    
    const filtersContainer = document.querySelector('collection-filters');
    if (filtersContainer && typeof filtersContainer.applyChanges === 'function') {
      filtersContainer.applyChanges();
    }
  }
}

customElements.define('search-form', SearchForm);
